import React from "react";

const Layout = ({ children }) => {
  return (
    <div style={{ maxWidth: 1000, margin: "auto" }}>
      <div
        style={{
          padding: 20,
          textAlign: "left",
          marginTop: 50,
        }}
      >
        <img src="catax.png" alt="logo" width="150px" />
      </div>
      {children}
    </div>
  );
};

export default Layout;
